export const PRO_PLAN_NAME = 'MobileMonkey Operator';
export const TEAM_PLAN_NAME = 'MobileMonkey Agency';
export const MONTH_PAYMENT = 'Month-to-Month';
export const COUPON_PAYMENT = 'Growth Marketing Summit Sign up';
export const PAGES_UPGRADE_COUNT = 9;
